import _ from './brand.module.scss'
import React from 'react'
import {Flex} from './flex'
import {$, $$$} from '../shared/class-name'
import {Link} from 'react-router-dom'

export const Symbol = ({className, secondary, children, size}) => {
    return <Flex
        className={$$$(_.symbolContainer, $(_.secondary, secondary), $(className))}
        style={{'--size': size}}
    >
        <div className={_.symbol}></div>
        <div className={_.complementaryContainer}>{children}</div>
    </Flex>
}

export const Logo = ({className, primary, secondary, size=24}) => {
    return <div className={$$$(_.logo, $(_.primary, primary), $(_.secondary, secondary), $(className))}
        style={{width:size, height:size}}
    ></div>
}

export const Mark = ({className, logo=false, secondary=false, size=12}) =>
    <span className={$$$(_.mark, $(_.secondary, secondary), $(className))}>
        {logo && <Logo secondary className={_.markLogo} size={size}/>}
        <span style={{fontSize: size}}>out of 195</span>
    </span>

export const LogoMark = ({className, size=28, to}) => {
    const Component = to ? Link : 'span'
    return <Component
        className={$$$(_.logoMark, $(_.clickable, !!to), $(className))}
        style={{fontSize:size}}
        {...(to && {to})}
    ><Logo size={size}/><span style={{marginLeft: 1}}>195</span></Component>
}


